import { render, staticRenderFns } from "./modal-production-write-fine.vue?vue&type=template&id=04f0cbc2&scoped=true&"
import script from "./modal-production-write-fine.vue?vue&type=script&lang=js&"
export * from "./modal-production-write-fine.vue?vue&type=script&lang=js&"
import style0 from "./modal-production-write-fine.vue?vue&type=style&index=0&id=04f0cbc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f0cbc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f0cbc2')) {
      api.createRecord('04f0cbc2', component.options)
    } else {
      api.reload('04f0cbc2', component.options)
    }
    module.hot.accept("./modal-production-write-fine.vue?vue&type=template&id=04f0cbc2&scoped=true&", function () {
      api.rerender('04f0cbc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/modal-production-write-fine.vue"
export default component.exports